import {ETimePeriod, ETimePickerType} from './types';

export default {
  timePlaceholder: {
    [ETimePickerType.HMS]: 'hh:mm:ss',
    [ETimePickerType.HM]: 'hh:mm',
    [ETimePickerType.MS]: 'mm:ss',
  },
  options: {
    [ETimePeriod.HOURS]: 'Hour',
    [ETimePeriod.MINUTES]: 'Min',
    [ETimePeriod.SECONDS]: 'Sec',
  },
  acceptButton: 'OK',
};
